//
import validate from "validate.js"

/**
 * 
 */
export default function (val) {
    return validate.isDate(new Date(val)) || "Formato incorrecto."
}
